import {PageTitle} from "../../../../Components/Landmarks";
import type { ContextProps } from '../../../../types';
import React, {useEffect, useState} from "react";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {loanHistoryApi} from "./loanHistoryApi";
import {LayoutFullWidth} from "../../../../Components/Layout";
import {LoanHistoryView} from "./LoanHistoryView";
import {LoanHistorySearchFormView} from "./LoanHistorySearchFormView";
import {createListFromArrayOfObjects} from "../../../../Utilities/Types/listUtilities";
import {loanHistory} from "./loanHistoryFactory";

export const LoanHistoryContainer = ({
                                         districts,
                                         handleApiCall,
                                         handleSetLoanHistorySearchCriteria,
                                         isLoading,
                                         loanHistorySearchCriteria,
                                         redirect,
                                         systemType,
                                         systemTypeText,
                                         userId,
                                     }: ContextProps) => {

        const [loanHistories, setLoanHistories] = useState<Record<string, unknown>[]>([]);
        const [dropDowns, setDropDowns] = useState<Record<string, unknown> | null>(null);
        const [students, setStudents] = useState<any[] | null>(null);
        const [totalRecords, setTotalRecords] = useState(0);

        const loadLoanHistoriesResults = (result: { data: Record<string, unknown>[]; totalRecords: number }) => {
            const loanHistories = result.data.map((history: Record<string, unknown>) => loanHistory(history));
            setLoanHistories(loanHistories);
            setTotalRecords(result.totalRecords);
        };

        const handleGetDropDowns = () => {
            handleApiCall(() => loanHistoryApi.getListsForDropDowns(systemType), (results: Record<string, unknown>) => setDropDowns(results));
        }

        const handleGetStudents = () => {
            handleApiCall(() => loanHistoryApi.getStudents({
                userId: userId,
                forDropDown: true,
            }), (results: Record<string, unknown>[]) => {
                setStudents(createListFromArrayOfObjects(results, `studentId`, `fullName`));
            });
        }

        useEffect(() => {

            if (isNullOrUndefined(districts) || districts.length === 0) return;

            if (!dropDowns)
                handleGetDropDowns();
            if (!students)
                handleGetStudents()

            if (loanHistorySearchCriteria.loadSearchResults) {
                handleApiCall(() => loanHistoryApi.getLoanHistories({
                    ...loanHistorySearchCriteria,
                    SystemType: systemType
                }), loadLoanHistoriesResults);
            }

        }, [districts, loanHistorySearchCriteria]);

        if (!loanHistorySearchCriteria || isNullOrUndefined(dropDowns)) return null;

        return <>
            <PageTitle h1={`Loan History - ${systemTypeText}`}/>
            {
                dropDowns && students &&
                <div className={`searchBox`}>
                    <div className={`searchBox__title`}>Search for Loan History</div>
                    <LoanHistorySearchFormView
                        dropDowns={dropDowns}
                        handleSetLoanHistorySearchCriteria={handleSetLoanHistorySearchCriteria}
                        isLoading={isLoading}
                        loanHistorySearchCriteria={loanHistorySearchCriteria}
                        students={students}
                    />
                </div>
            }

            <LayoutFullWidth className={`catalog`}>
                <header>
                    <h2>Search Results</h2>
                </header>

                <LoanHistoryView
                    handleSetLoanHistorySearchCriteria={handleSetLoanHistorySearchCriteria}
                    loanHistories={loanHistories}
                    loanHistorySearchCriteria={loanHistorySearchCriteria}
                    redirect={redirect}
                    totalRecords={totalRecords}
                />
            </LayoutFullWidth>
        </>;
    }
;
